export default "__VITE_ASSET__34ae6bf7__"